import { AssigneeAvatar } from "./AssigneeAvatar";

/**
 * The task's owner — who is accountable, as opposed to who is working it.
 *
 * Avatar only, matching the assignee cell: names belong in the detail rail, not
 * in a scanning column. The accessible name is prefixed with "Owner:" so a row
 * whose owner and assignee are the same person still exposes two
 * distinguishable targets rather than one ambiguous duplicate.
 */
export function TaskOwnerIdentity(props: {
  readonly name: string | null;
  readonly avatarUrl: string | null | undefined;
}) {
  if (props.name === null) {
    return <span className="text-meta text-muted-foreground/50 md:text-xs">—</span>;
  }
  return (
    <span
      role="img"
      aria-label={`Owner: ${props.name}`}
      title={`Owner: ${props.name}`}
      className="inline-flex size-5 shrink-0 items-center justify-center overflow-hidden rounded-full ring-1 ring-border"
    >
      <span aria-hidden className="contents">
        <AssigneeAvatar name={props.name} avatarUrl={props.avatarUrl ?? null} />
      </span>
    </span>
  );
}
